export const REQUEST_ACCESS_EXPERIMENT_FLAG_V3 =
  'apollo.web.request-access-when-blocked-v3';

export enum AUTO_INVITE_MESSAGES {
  SUCCESS = 'You successfully added a member to the board',
  ERR0R = 'Error Occured',
}

export interface Member {
  id: string;
  fullName: string;
  email: string;
  get: () => string;
}
export interface Board {
  id: string;
  addMember: (member: Member | undefined, traceId: string) => void;
  attributes: { idOrganization: string };
}

export enum InviteRestrictionReason {
  PERMITTED = 'permitted',
  MEMBER_ALREADY_ON_BOARD = 'member-already-on-board',
  MEMBER_BLOCKED = 'member-blocked',
  MEMBER_NOT_IN_ORG = 'member-not-in-org',
  MEMBER_NOT_IN_ENT = 'member-not-in-enterprise',
  MEMBER_NOT_IN_ORG_OR_ENT = 'member-not-in-org-or-enterprise',
  ORG_LESS_BOARD = 'org-less-board',
  GUEST_INVITE = 'guest-invite',
}
// AUTO INVITE MEMBER SUCCESS FLOW

const SUCCESS_CONTENT_TITLE = ({ fullName }: { fullName: string }): string =>
  `${fullName} has joined your board`;
const SUCCESS__CONTENT_TEXT = 'You can start collaborating together.';
const SUCCESS_BUTTON_TEXT = 'Go to board';
const DESCRIPTION = 'Added to board:';

// WORKSPACE RESTRICTED CONTENT MODAL

const WORKSPACE_DIALOG_TITLE = ({ multiBoardGuest = false }) =>
  multiBoardGuest ? 'Add as a multi-board guest' : 'Add to Workspace first';
const WORKSPACE_AVATAR_DESCRIPTION = (
  workspaceName: string,
  multiBoardGuest?: boolean,
): string =>
  multiBoardGuest
    ? 'Add as multi-board guest:'
    : `Add to ${workspaceName} Workspace:`;
const WORKSPACE_DIALOG_DESCRIPTION =
  'Once added, they can join all visible boards and create new boards. You’ll be automatically billed for them too.';
const WORKSPACE_DIALOG_CANCEL_BUTTON = 'Cancel';
const WORKSPACE_DIALOG_ADD_BUTTON = ({ multiBoardGuest = false }): string =>
  multiBoardGuest ? 'Add multi-board guest' : 'Add to Workspace';

// INVITE ERROR CONTENT MODAL

const INVITE_ERROR_CONTENT_TITLE = 'Contact your admin';
const INVITE_ERROR_CONTENT_TEXT =
  "We're having trouble adding your teammate. Contact your Workspace or Enterprise admin for help.";
const INVITE_ERROR_BUTTON_TEXT = 'OK, got it';

// ERROR CONTENT MODAL

const ERROR_CONTENT_TITLE = 'Something went wrong';
const ERROR_CONTENT_TEXT =
  "We're having trouble adding your teammate. Ga back to the request access email, and select Add to board to try again.";

export const constants = {
  AUTO_INVITE_MESSAGES,
  REQUEST_ACCESS_EXPERIMENT_FLAG_V3,
  SUCCESS_CONTENT_TITLE,
  SUCCESS__CONTENT_TEXT,
  SUCCESS_BUTTON_TEXT,
  DESCRIPTION,
  WORKSPACE_DIALOG_TITLE,
  WORKSPACE_AVATAR_DESCRIPTION,
  WORKSPACE_DIALOG_DESCRIPTION,
  WORKSPACE_DIALOG_CANCEL_BUTTON,
  WORKSPACE_DIALOG_ADD_BUTTON,
  INVITE_ERROR_CONTENT_TEXT,
  INVITE_ERROR_CONTENT_TITLE,
  INVITE_ERROR_BUTTON_TEXT,
  ERROR_CONTENT_TITLE,
  ERROR_CONTENT_TEXT,
};
